export const types = {
  GET_LANGUAGES: 'GET_LANGUAGES',
  GET_LANGUAGES_FULFILLED: 'GET_LANGUAGES_FULFILLED'
};
